import React from 'react';
import './DateInput.scss';
import DatePicker, {registerLocale} from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import pl from "date-fns/locale/pl";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import {constructClassNames, formatDate} from "../../helpers/helpers";

const DateInput = (
  { name, value, onChange, label, required, error, disabled, small, noMargin }
) => {
  registerLocale("pl", pl);

  const dateInputClasses = [
    {name: 'noMarginDateInput', condition: !!noMargin},
  ];

  const inputFieldClasses = [
    {name: 'datePickerInputSmall', condition: !!small},
    {name: 'disabled', condition: !!disabled},
    {name: 'emptyRequired', condition: (!value || !value?.length) && required}
  ];

  const iconClasses = [
    {name: 'iconSmall', condition: !!small}
  ];

  return (
    <div className={constructClassNames('DateInput', dateInputClasses)}>
      {!!label && (
        <label className='inputLabel'>
          {label}{required ? '*' : ''}
        </label>
      )}
      <DatePicker
        selected={value && value.includes('-') ? new Date(value) : ''}
        onChange={date => !disabled ? onChange(name, date ? formatDate(date) : '', false, true, 'date') : null}
        dateFormat="yyyy-MM-dd"
        className={constructClassNames('datePickerInput', inputFieldClasses)}
        wrapperClassName='datePickerWrapper'
        disabled={disabled}
        locale='pl'
      />
      <div className={constructClassNames('calendarIcon', iconClasses)}>
        <CalendarMonthIcon fontSize={!!small ? 'small' : 'medium'} />
      </div>
    </div>
  );
}

export default DateInput;
